import React from 'react';

function ManagesDashboardPage() {
    return <div>ManagesDashboardPage</div>;
}

export default ManagesDashboardPage;
